import(/* webpackMode: "eager" */ "/vercel/path0/components/HomePage/OurClient.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/HomePage/services/ServiceCard.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/HomePage/successstory/SuccessStoryGrid.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/HomePage/techstackcomponents/TechStack.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/HomePage/Testimonials.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/vercel/path0/components/ui/accordion.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/NudgeCard.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"components/HomePage/HeroSection.jsx\",\"import\":\"Libre_Baskerville\",\"arguments\":[{\"weight\":\"400\",\"style\":\"italic\",\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false}],\"variableName\":\"libreBaskerville\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"fonts/index.js\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/oceanwide/oceanwide-semibold.woff2\",\"variable\":\"--oceanwide-font\",\"display\":\"swap\"}],\"variableName\":\"oceanwide\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"fonts/index.js\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/sf_pro/sf_pro.woff2\",\"display\":\"swap\",\"variable\":\"--sf-pro\"}],\"variableName\":\"sf_pro\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"fonts/index.js\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/proxima_nova/ProximaNova.woff2\",\"variable\":\"--proxima-font\",\"display\":\"swap\"}],\"variableName\":\"proxima_nova\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/Border.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/check.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/SplBorder.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/x.png");
